import React, { useState } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import PadronServicio from "../../../servicios/Padron";
import { Notificar } from "../Notificador";
import DatosBasicosPersona from "./DatosBasicosPersona";
import TipoPersonaDropdown from "../Dropdowns/TiposPersona/TipoPersonaDropdown";

function SeleccionarPersonaModal({ boton, actualizarPersona }) {
  const [show, setShow] = useState(false);
  const [tipoPersona, setTipoPersona] = useState("0");
  const [identificacion, setIdentificacion] = useState("");
  const [persona, setPersona] = useState();

  const handleClose = () => {
    resetearValores();
    setShow(false);
  };

  const handleShow = () => setShow(true);

  const botonMostrarModal = React.cloneElement(boton, { onClick: handleShow });

  const resetearValores = () => {
    setTipoPersona("0");
    setIdentificacion("");
    setPersona();
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!persona) {
      Notificar("error", "Primero debe buscar la persona.");
      return;
    }

    actualizarPersona(persona);
    handleClose();
  };

  async function obtenerPersona() {
    const resultado = await PadronServicio.ObtengaPersonaUnificada({
      Codigo: identificacion,
      TipoPersona: {
        Codigo: tipoPersona,
      },
    });

    if (!resultado.esValido) {
      Notificar("error", resultado.errores);
      return;
    }

    setPersona(resultado);
  }

  return (
    <>
      {botonMostrarModal}

      <Modal
        show={show}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
        size="xl"
      >
        <Modal.Header closeButton>
          <Modal.Title>Seleccionar Persona</Modal.Title>
        </Modal.Header>
        <Form onSubmit={handleSubmit}>
          <Modal.Body>
            <div className="card shadow mb-4">
              <div className="card-header">
                <h6 className="m-0 font-weight-bold text-primary">
                  Filtros de Búsqueda
                </h6>
              </div>
              <div className="card-body">
                <div className="form-inline">
                  <div className="form-group mr-4">
                    <label htmlFor="tipoPersona" className="mr-2">
                      Tipo Persona
                    </label>
                    <TipoPersonaDropdown
                      className="form-control"
                      id="tipoPersona"
                      name="tipoPersona"
                      value={tipoPersona}
                      onChange={(e) => setTipoPersona(e.target.value)}
                    />
                  </div>
                  <div className="form-group mr-4">
                    <label htmlFor="identificacion" className="mr-2">
                      Identificación
                    </label>
                    <input
                      className="form-control"
                      id="identificacion"
                      name="identificacion"
                      type="text"
                      maxLength="30"
                      value={identificacion}
                      onChange={(e) => setIdentificacion(e.target.value)}
                    />
                  </div>
                  <button
                    id="btnBuscarIdentificaciones"
                    onClick={obtenerPersona}
                    type="button"
                    className="btn btn-primary btn-icon-split"
                  >
                    <span className="icon text-white-50">
                      <i className="fas fa-search"></i>
                    </span>
                    <span className="text">Buscar</span>
                  </button>
                </div>
              </div>
            </div>

            {persona ? (
              <DatosBasicosPersona personaUnificada={persona} />
            ) : null}
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleClose}>
              Cancelar
            </Button>
            <Button variant="primary" type="submit">
              Seleccionar
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>
    </>
  );
}

export default SeleccionarPersonaModal;
